module.exports = function(app) {
  app.filter('removeCurrentId', function() {
      return function(array, id) {
          var filtered = [];
          if (id) {
            angular.forEach(array, function(item) {
              if (item['_id'] != id) {
                filtered.push(item);
              }
            });
          }else{
              filtered=array;
          }
          return filtered;
      }
  })
  app.filter('sortingCount', function() {
    return function(array, type, prop) {
      if(!array || array.length==0) return []
      return array.sort(function(a,b) {
        if(type=='descending') {
          if(isFinite(parseInt(b[prop]) - parseInt(a[prop]))) {
            return parseInt(b[prop])-parseInt(a[prop])
          } else {
            // NaN  na kraj
            return isFinite(parseInt(a[prop]))? -1:1
          } 
        } else if(type=='ascending') {
          if(isFinite(parseInt(a[prop]) - parseInt(b[prop]))) {
            return parseInt(a[prop])-parseInt(b[prop])
          } else {
            // NaN  na kraj
            return isFinite(parseInt(a[prop]))? -1:1
          }
        }
      })
    }
  })
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/filter/arrayFilters.js
// module id = 455
// module chunks = 0